console.log(process.env.NODE_ENV, "+_+__+_+____+")


const devUri = {
    sso:'http://test.signin.askbot.cn',
    expired: 'http://portal.test.askbot.cn/#/expired'
};

const prodUri = {
    sso:'https://signin.askbot.cn',
    expired: 'https://portal.askbot.cn/#/expired'
};

const redirectUri = {
    development:devUri,
    test:devUri,
    testproduction:devUri,
    production:prodUri
};

function redirect2LoginPage(){
    let redirect = window.location.origin + '/#/auth';
    console.log('redirect:', redirect)
    window.location = redirectUri[process.env.VUE_APP_ASK_ENV].sso + '?redirect_uri=' + encodeURIComponent(redirect)
}


export {redirectUri,redirect2LoginPage}